import { ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { MessageService } from 'primeng/api';
import { PanelList } from '../../shared/models/panel-list';
import {AcknowledementConstants} from '../acknowledement-constants'
import { AcknowledgementInteractionService } from '../services/acknowledgement-interaction.service';
import { AcknowledgementService } from '../services/acknowledgement.service';
import {TooltipModule} from 'primeng/tooltip';
import { ConfirmationService, Message } from 'primeng/api';
import { CommonService } from '../../shared/services/common.service';

@Component({
  selector: 'app-acknowledgement-management',
  templateUrl: './acknowledgement-management.component.html',
  styleUrls: ['./acknowledgement-management.component.scss']
})
export class AcknowledgementManagementComponent implements OnInit {
  isAcknowledgementSliderOpen = false;
  @Input() documentNumber!: string;
  @Input() documentVersion!: string;
  @Input() documentEffectiveDate?: Date;
  @Input() documentPhaseNumber!: number;
  @Input() nextVersionPhase!: number;
  @Input() isLoggedInUserAdmin:boolean = false;
  isaddAcknowledgementBtnEnabled = true;
  ispanelListDataAvailable:boolean=true;
  showAcknowledgementConfirmationModal=false;
  acknowledgementIdToUpdate:any;
  acknowledgementConfirmationText:string=AcknowledementConstants.Acknowledgement_Confirmation_Modal_Text;
  documentAcknowledgementData:PanelList={
    lists:[],
    filters:[],
    sort:[]
  };
  lists : any=[]
  isDeleteAcknowledgementButtonEnabled:boolean = false;
  acknowledgeIdToDelete:any;
  isDeleteAcknowledgementModal:boolean = false;
  showLoader : boolean = false;

  constructor(private acknowledgementService: AcknowledgementService,private messageService: MessageService,private acknowledgementInteractionService:AcknowledgementInteractionService,
    private cd: ChangeDetectorRef, private confirmationService: ConfirmationService, private commonService: CommonService) {}

  ngOnInit(): void {
    this.displayAcknowledgementBtn();
    this.getAcknowledgementDetailsForDocument();
    this.acknowledgementInteractionService.OnAcknowledgementConfirmationCompleted()
      .subscribe((isUpdated:boolean) => this.AcknowledgementConfirmationCompleted(isUpdated));
      this.acknowledgementInteractionService.OnAcknowledgementConfirmationCompleted()
      .subscribe((isUpdated:boolean)=>this.AcknowledgementAdded((isUpdated)));
  }

  addAcknowledgement() {
    this.isAcknowledgementSliderOpen = !this.isAcknowledgementSliderOpen;
  }


  AcknowledgementConfirmationCompleted(isUpdated: boolean) {
    if (isUpdated) {
      setTimeout(() => {
        this.getAcknowledgementDetailsForDocument();
      }, 1000);
      
    }
  }
  AcknowledgementAdded(isUpdated: boolean) {
    if (isUpdated) {
      setTimeout(() => {
        this.getAcknowledgementDetailsForDocument();
      }, 1000);
      
    }
  }

  displayAcknowledgementBtn() {
    if (
      AcknowledementConstants.documentPhasenumbersToHideAcknowledgementBtn1.includes(
        this.documentPhaseNumber
      ) ||
      AcknowledementConstants.documentPhasenumbersToHideAcknowledgementBtn2.includes(
        this.nextVersionPhase
      )
    ) {
      this.isaddAcknowledgementBtnEnabled = false;
    } else {
      this.isaddAcknowledgementBtnEnabled = true;
    }
  }

  closeAcknowledgementSlider(isSliderActive: boolean) {
    this.isAcknowledgementSliderOpen = isSliderActive;
  }


  addSorting():void{
    this.documentAcknowledgementData.sort = [];
    this.documentAcknowledgementData.enableSort=true;
    this.documentAcknowledgementData.sort?.push(    
      {
        sortFieldDisplayName:"Assigned User",
        sortFieldName:"assignedInternalUser",
      });
    this.documentAcknowledgementData.sort?.push(    
      {
        sortFieldDisplayName:"Status",
        sortFieldName:"status",
      });
   
        this.documentAcknowledgementData.sort?.push(    
          {
            sortFieldDisplayName:"Type",
            sortFieldName:"type",
          }); 

    
  }
  addFilters():void{
    this.documentAcknowledgementData.filters = [];
    this.documentAcknowledgementData.enableFilter=true;
    this.documentAcknowledgementData.filters?.push(    
      {
        filterDisplayName:"Assigned User",
        filterFieldName:"assignedInternalUser",
      });
    this.documentAcknowledgementData.filters?.push(    
      {
        filterDisplayName:"Status",
        filterFieldName:"status",
      });
   
        this.documentAcknowledgementData.filters?.push(    
          {
            filterDisplayName:"Type",
            filterFieldName:"type",
          }); 
  }

  getAcknowledgementDetailsForDocument(){
    this.showLoader = true;
    this.acknowledgementService.getAcknowledgementDetails(this.documentNumber,this.documentVersion).subscribe(
      serviceData => {
        this.documentAcknowledgementData.lists=serviceData;
        this.ispanelListDataAvailable = !this.commonService.IsListEmpty(serviceData);
        this.showLoader = false;
        this.addFilters();
        this.addSorting();
        this.documentAcknowledgementData = {...this.documentAcknowledgementData};       
      });   
  }

  openAcknowledgementConfirmationModal(acknowledgementId:any){
    this.acknowledgementIdToUpdate=acknowledgementId;
    this.showAcknowledgementConfirmationModal = true;
  }

  closeConfirmationModal = () => {
    this.showAcknowledgementConfirmationModal = false;
  }

  updateAcknowledgementData()
  {
this.acknowledgementService.updateAcknowledgementOnConfirmation(this.documentNumber,this.documentVersion,this.acknowledgementIdToUpdate).subscribe(
      serviceData => {
        this.closeConfirmationModal();
        this.messageService.add({
          severity: AcknowledementConstants.Severity_Success,
          summary: AcknowledementConstants.Acknowledgement_Updated_Successfully_OnConfirmation_Message
        });
        this.acknowledgementInteractionService.acknowledgementConfirmationCompleted.next(true);
      this.cd.detectChanges();
      });   
  }

  deleteAcknowledgement(acknowledementId:any){
      this.isDeleteAcknowledgementModal = true;
      this.acknowledgeIdToDelete=acknowledementId;
  }

  closeDeleteAcknowledgementModal(event:any){
    this.isDeleteAcknowledgementModal = event;
    setTimeout(() => {
      this.getAcknowledgementDetailsForDocument();
    }, 1000);
  }
}
